import { useEffect } from "react";

interface MetaOptions {
  title?: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content?: string) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
  }, [title, description, keywords]);
}